import { Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import { useSelector } from "react-redux";

const Footer = () => {
    const state = useSelector((state) => state);
    const { channel } = useSelector((state) => state.staticData);

    const defaultFooter = () => {
        return (
            <Container className="xxl">
                <Row>
                    <Col className="py-2">Во делот „Архива на финансиски извештаи“ можете да ги најдете сите финансиски извештаи објавени од 01.01.2006 до 30.06.2006 година.</Col>
                    <div className="vr" />
                    <Col className="py-2">Финансиските извештаи доставени до Берзата пред 01.01.2006 година може да се најдат на следниот линк. Вестите објавени заклучно со 23.01.2006 година може да се најдат преку пребарување на следниот линк.</Col>
                    <div className="vr" />
                    <Col className="py-2">
                        <Nav vertical className="footer-css-links">
                            <NavItem>
                                <NavLink href="http://localhost:62167/Rss.aspx?lang=MK&PartyId=">
                                СЕИ-Нет вести
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="http://localhost:62167/Rss.aspx?lang=MK">
                                Вести од берзатa
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="http://localhost:62167/RssReports.aspx?lang=MK">
                                Извештаи
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="copyright">
                        © {new Date().getFullYear()}{" "}
                            <a
                                href="https://mse.mk"
                                target="_blank"
                            >
                                Македонска берза АД
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
    const anyDynamicFooter = () => {
        let result =  channel?.localizedTerms
            && state.account?.language?.languageId;

        return result;
    }
    const getFooterData = () => {
        var result = channel?.localizedTerms?.find(l => l.languageId == state.account?.language?.languageId);

        // console.log('getFooterData: ', result?.footerHtml);
        return result?.footerHtml??'';
    }

    return (
        <footer className="footer">
            {
                anyDynamicFooter()
                    ? (<div dangerouslySetInnerHTML={{ __html: getFooterData() }} />)
                    : defaultFooter()
            }
        </footer>
    )
};

export default Footer;